angular.module('login').factory('LoginService',
    ['LocalStorageRepository',
        '$q',
        '$location',
        function(
            LocalStorageRepository,
            $q,
            $location) {
            'use strict';

            function getClientConfig(){
                var url = $location.absUrl();
                var splitResult = url.toLowerCase().split('/portal/');
                if (splitResult.length === 2) {
                    var hostUrl = splitResult[0];
                    var clientIdResult = splitResult[1].split('/');
                    var clientId = clientIdResult[0];
                    var clientConfig = {
                        ClientId: clientId,
                        HostUrl: hostUrl
                    };
                    return $q.when(clientConfig);

                } else {

                    return $q.when(false);
                }
            }

            return {
                getClientConfig: getClientConfig
            };

        }]);